export default __webpack_public_path__ + "static/media/servicebreak2.5fabe8fd.png";